import React from 'react';
import { useTranslations } from 'use-intl';
import StepIndicator from '@/stories/Components/StepIndicator/StepIndicator';
import { RegistryStatus } from '@/graphql/__generated__/onboarding';

interface StatusTimelineProps {
	registry: {
		registryStatus?: RegistryStatus | null;
	};
}

const StatusTimeline: React.FC<StatusTimelineProps> = ({ registry }) => {
	const t = useTranslations('RegistryDetails');

	const registrySteps = [
		t('ContactInformationStepStatus'),
		t('PersonalInformationStepStatus'),
		t('BirthInformationStepStatus'),
		t('TaxInformationStepStatus'),
		t('OfficialAddressStepStatus'),
		t('ProofOfLifeStepStatus'),
		t('PendingReview'),
		t('CorrectionsRequested'),
		registry.registryStatus === RegistryStatus.APPROVED ? t('APPROVED') : t('REJECTED')
	];

	const getStepIndex = (status: RegistryStatus | null | undefined): number => {
		if (!status) return 0;

		const stepMap: Record<RegistryStatus, number> = {
			[RegistryStatus.CONTACT_INFORMATION_REGISTERED]: 1,
			[RegistryStatus.PERSONAL_INFORMATION_REGISTERED]: 2,
			[RegistryStatus.BIRTH_INFORMATION_REGISTERED]: 3,
			[RegistryStatus.TAX_INFORMATION_REGISTERED]: 4,
			[RegistryStatus.OFFICIAL_ADDRESS_REGISTERED]: 5,
			[RegistryStatus.PROOF_OF_LIFE_REGISTERED]: 6,
			[RegistryStatus.COMPLETED]: 7,
			[RegistryStatus.CORRECTIONS_REQUESTED]: 8,
			[RegistryStatus.APPROVED]: 9,
			[RegistryStatus.REJECTED]: 9
		};
		return stepMap[status] || 0;
	};

	const currentStep = getStepIndex(registry?.registryStatus);

	return <StepIndicator steps={registrySteps} currentStep={currentStep} />;
};

export default StatusTimeline;
